<template>
  <div class="Exams">
    <navbar></navbar>
     <Header title=" الواجبات" />
     <div class="content d-flex aside-row-complete">
      <HwAside @tab-selected="currentTab = $event" />
      <component :is="currentTab" class="exams-content"></component>
    </div>
    <footer-component></footer-component>
  </div>
</template>

<script>
import Header from '@/components/Header.vue';
import Navbar from '@/components/Navbar.vue';
import NewHw from '@/components/NewHw.vue';
import HwAside from '@/components/HwAside.vue';
import CompletedHw from '@/components/CompletedHw.vue';
import FooterComponent from '@/components/FooterComponent';

export default {
  name: 'HomeWork',
  components: {
    Header,
    Navbar,
    NewHw,
    HwAside,
    CompletedHw,
    FooterComponent,
  },
  data() {
    return {
      currentTab: 'NewHw' // Initialize with NewExams component
    };
  }
};
</script>
